import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'MapValueFromObject'
})
export class MapValueFromObjectPipe implements PipeTransform {

  transform(object: any, propertyName: any,
    isArray: boolean, arrPropName?: string, value?, valuePropName?): any {
    let val;
    if (object == null) {
      return;
    }
    if (isArray) {
      const arr = object[propertyName] as [];
      if (arr != null) {
        const arrVal = arr.find(x => x[arrPropName] === value);
        val = arrVal != null ? arrVal[valuePropName] : null;
      }
      else if (propertyName === '') {
        const objectAsArray = object as [];
        val = objectAsArray.find(x => x[arrPropName] === value)[valuePropName];
      }
    }
    else {
      val = object[propertyName];
    }
    return val;
  }

}
